(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const prepared = new WeakMap();
  const seen = new Set();
  const selectors = '.price-list, #tkb-produtos .pp, #tkb-kits .tb-combo__footer > div, #tkb-comprar .price';
  const keyFor = node => {
    const context = node.closest('#mini-cart') ? 'drawer' : node.closest('main-cart, .cart, #shopify-section-main-cart') ? 'cart' : location.pathname;
    return context + ':' + node.textContent.replace(/\s+/g, ' ').trim();
  };
  const reveal = node => {
    const key = keyFor(node);
    if (!seen.has(key) && !reduced.matches) node.classList.add('tb-price-play');
    seen.add(key);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting || entry.intersectionRatio < .25) continue;
      reveal(entry.target);
      observer.unobserve(entry.target);
    }
  }, { threshold: .25 }) : null;
  function scan() {
    for (const node of document.querySelectorAll(selectors)) {
      const old = node.querySelector('.price--compare, .old, .tb-combo__old');
      const sale = node.querySelector('.price--highlight, .now, .tb-combo__price');
      if (!old || !sale) {
        node.classList.remove('tb-price-pair', 'tb-price-play');
        observer?.unobserve(node);
        prepared.delete(node);
        continue;
      }
      if (prepared.get(node) === old && sale.classList.contains('tb-price-sale')) continue;
      prepared.set(node, old);
      node.classList.remove('tb-price-play');
      node.classList.add('tb-price-pair');
      old.classList.add('tb-price-old');
      sale.classList.add('tb-price-sale');
      if (observer) observer.observe(node); else reveal(node);
    }
  }
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan);
  scan();
})();

/* Progressive card entrance: visible by default, one animation per card. */
(() => {
  const selector = '#tkb-kits .tkb-kc, #tkb-produtos .tkb-pc';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  let observer;
  const reveal = card => {
    if (seen.has(card)) return;
    seen.add(card);
    observer?.unobserve(card);
    if (motion.matches || card.contains(document.activeElement)) return;
    card.classList.add('tb-card-reveal');
    card.addEventListener('animationend', () => card.classList.remove('tb-card-reveal'), { once: true });
  };
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) reveal(entry.target);
      }
    }, { threshold: 0.08 });
  }
  const scan = () => {
    for (const card of document.querySelectorAll(selector)) {
      if (seen.has(card)) continue;
      if (observer && !motion.matches) observer.observe(card);
      else seen.add(card);
    }
  };
  document.addEventListener('focusin', event => {
    const card = event.target.closest(selector);
    if (!card) return;
    seen.add(card);
    observer?.unobserve(card);
    card.classList.remove('tb-card-reveal');
  });
  motion.addEventListener('change', () => {
    if (!motion.matches) return;
    observer?.disconnect();
    for (const card of document.querySelectorAll(selector)) {
      seen.add(card);
      card.classList.remove('tb-card-reveal');
    }
  });
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
